function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, $hooks, JSON, Object, isMenuLoading, keydownProxyEl, searchFilter, tooltipData) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'mp-multi-events-menu': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
          "attrs": __vjadeStringifyAttrsIfObj({
            'show-select-all': !isMenuLoading,
            'show-select-all-matching': !isMenuLoading,
            'multiple': $attr(`multiple`),
            'search-filter': searchFilter,
          }),
          "on": {
            click: ev => ev.stopPropagation(),
            clickItem: $helpers.handleItemClick,
            selectAll: $helpers.handleSelectAll,
            selectAllMatching: $helpers.handleSelectAllMatching,
            focusItem: $helpers.showItemDetails,
          },
          "props": {
            keydownProxyEl,
            sections: $helpers.getMenuSections(),
          },
        }));
        __jade_nodes = __jade_nodes.concat(($attr(`open`) && tooltipData) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-context-panel", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`tooltip-data`, null)
            },
            "attrs": __vjadeStringifyAttrsIfObj({
              'tooltip-data': JSON.stringify(tooltipData),
              'position-parent-selector': `mp-drop-menu`,
            }),
            "on": {
              tooltipContextAction: $helpers.propagateEvent,
              tooltipContextEditDescription: $helpers.propagateEvent,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
          "attrs": __vjadeStringifyAttrsIfObj({
            disabled: !$helpers.canCommit()
          }),
          "on": {
            click: $helpers.onCommitClick
          },
          "class": {
            'mp-button-bar-primary': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat($helpers.getCommitLabel());;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "$hooks" in locals ? locals.$hooks : typeof $hooks !== "undefined" ? $hooks : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "isMenuLoading" in locals ? locals.isMenuLoading : typeof isMenuLoading !== "undefined" ? isMenuLoading : undefined, "keydownProxyEl" in locals ? locals.keydownProxyEl : typeof keydownProxyEl !== "undefined" ? keydownProxyEl : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined, "tooltipData" in locals ? locals.tooltipData : typeof tooltipData !== "undefined" ? tooltipData : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;